module.exports = __webpack_public_path__ + "fonts/SF-Pro-Display-BoldItalic.9d7f6005.otf";